import { useLocation, useNavigate } from 'react-router-dom';

import { parseParams } from './constants/getQueryString';
import updateQueryStringParameter from './updateQueryStringParameter';

export const HOFollowCustomerPagination = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (page: number, pageSize?: number | undefined) => {
    const search = updateQueryStringParameter(parseParams(location.search), {
      page: page,
      page_size: pageSize,
    });
    const url = location.pathname + (search !== '' && `?`) + search;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    navigate(url, {
      state: location?.state,
    });
  };
};
